import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#1F2125",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-opacity": ".65",
      "stroke-width": "1.5",
      d: "M7 9.334V7m0-2.333h.006M12.833 7A5.833 5.833 0 1 1 1.166 7a5.833 5.833 0 0 1 11.667 0"
    }, null, -1)
  ]))]))
}
export default { render: render }